import React from 'react'
import { cn } from '../utlis/cn'

type ButtonProps = {
    className?: string
    variant?: 'primary' | 'secondary' | 'glow'
    children?: React.ReactNode
    forwardedRef?: React.ForwardedRef<HTMLButtonElement>
} & React.ButtonHTMLAttributes<HTMLButtonElement>

const commonBorder = 'rounded-[12px]'
const commonStyle = 'inline-flex items-center justify-center h-full aspect-square cursor-pointer'

export const ControlButton = React.forwardRef<HTMLButtonElement, ButtonProps>(function (
    { className, variant, children, ...rest },
    ref
) {
    if (variant === 'primary') {
        return <PrimaryButton className={className} children={children} {...rest} forwardedRef={ref} />
    }
    if (variant === 'secondary') {
        return <SecondaryButton className={className} children={children} {...rest} forwardedRef={ref} />
    }
    if (variant === 'glow') {
        return <GlowButton className={className} children={children} {...rest} forwardedRef={ref} />
    }
    return null
})

function PrimaryButton({ className, children, forwardedRef, ...rest }: ButtonProps) {
    const style = 'text-black font-medium'
    const bg = 'bg-muse-primary-gradient'

    return (
        <button
            className={cn(commonStyle, style, bg, commonBorder, rest.disabled && 'cursor-not-allowed', className)}
            {...rest}
            ref={forwardedRef}
        >
            {children}
        </button>
    )
}

function SecondaryButton({ className, children, forwardedRef, ...rest }: ButtonProps) {
    const style = 'transparent border-muse-toplit hover:bg-white/5'

    return (
        <button
            className={cn(
                commonStyle,
                style,
                commonBorder,
                rest.disabled && 'cursor-not-allowed opacity-70',
                className
            )}
            {...rest}
            ref={forwardedRef}
        >
            {children}
        </button>
    )
}

function GlowButton({ className, children, forwardedRef, ...rest }: ButtonProps) {
    const style = 'relative overflow-clip transparent border-muse-toplit hover:bg-white/5'
    const bg = 'shadow-glow'

    return (
        <button
            className={cn(commonStyle, style, commonBorder, bg, rest.disabled && 'cursor-not-allowed', className)}
            {...rest}
            ref={forwardedRef}
        >
            <div className="absolute bottom-0 bg-white left-0 right-0 h-[2px] blur-md"></div>
            {children}
        </button>
    )
}
